import { cn } from '@/helpers/utils'
import { useTranslation } from '@/translations/i18n'

/**
 * A viewer-facing explainer for the percentages on the chart, written as one
 * top-to-bottom column so it reads like prose rather than a dashboard of boxes.
 *
 * Deliberately speaks in shares of the area's point pool, never in the points
 * behind them: the estimates live in code and the chart only ever shows
 * percentages. The band colours mirror the semaphore dots in the header.
 */
function RoadmapPercentageGuide() {
	const { t } = useTranslation()

	const bands = [
		{ className: 'bg-success-500', label: t('roadmaps:guide_band_low') },
		{ className: 'bg-warning-400', label: t('roadmaps:guide_band_mid') },
		{ className: 'bg-danger-500', label: t('roadmaps:guide_band_high') },
		{ className: 'bg-purple-600', label: t('roadmaps:guide_band_over') }
	]

	const sections = [
		{
			title: t('roadmaps:guide_activity_title'),
			body: t('roadmaps:guide_activity')
		},
		{
			title: t('roadmaps:guide_week_title'),
			body: t('roadmaps:guide_week')
		}
	]

	return (
		<div className='rounded-xl border border-neutral-200 bg-neutral-50 p-4 text-xs'>
			<div className='flex max-w-2xl flex-col gap-3'>
				<div>
					<p className='font-semibold text-neutral-900 text-sm'>
						{t('roadmaps:guide_title')}
					</p>
					<p className='mt-1 text-neutral-600'>
						{t('roadmaps:guide_intro')}
					</p>
				</div>

				{sections.map((section) => (
					<div key={section.title}>
						<p className='font-medium text-neutral-800'>
							{section.title}
						</p>
						<p className='mt-0.5 text-neutral-600'>
							{section.body}
						</p>
					</div>
				))}

				<div>
					<p className='font-medium text-neutral-800'>
						{t('roadmaps:guide_scale_title')}
					</p>
					<div className='mt-1 flex flex-col gap-1'>
						{bands.map((band) => (
							<div
								className='flex items-center gap-1.5'
								key={band.label}
							>
								<span
									className={cn(
										'size-2 shrink-0 rounded-full',
										band.className
									)}
								/>
								<span className='text-neutral-600'>
									{band.label}
								</span>
							</div>
						))}
					</div>
				</div>
			</div>
		</div>
	)
}

export { RoadmapPercentageGuide }
